import React from 'react';
import Icon from '../../../components/AppIcon';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const ComplianceTypeChart = ({ data }) => {
  const chartData = data?.map(item => ({
    name: item?.name,
    value: item?.total,
    rate: item?.rate,
    color: item?.color
  }));

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Compliance by Regulation Type</h3>
          <p className="text-sm text-muted-foreground">Distribution across regulatory categories</p>
        </div>
        <Icon name="PieChart" size={20} color="var(--color-muted-foreground)" />
      </div>

      <div className="h-64 mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, rate }) => `${name}: ${rate}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {chartData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="space-y-3">
        {data?.map((item, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-3">
              <div className="w-4 h-4 rounded" style={{ backgroundColor: item?.color }} />
              <div>
                <p className="text-sm font-medium text-foreground">{item?.name}</p>
                <p className="text-xs text-muted-foreground">
                  {item?.completed}/{item?.total} completed
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold text-foreground">{item?.rate}%</p>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <span className="text-destructive">{item?.overdue} overdue</span>
                <span className="text-orange-500">{item?.upcoming} upcoming</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComplianceTypeChart;